import { createSlice } from "@reduxjs/toolkit";
import { downloadBiography, fetchBiographies } from "./action";

const initialState = {
  biographies: {
    success: null,
    loading: false,
    list: [],

  },
  listData: {
    list: null,
    count: 0,
    loading: false,
    downloading: false,
    downloadingId: null,
  }
};

const biographySlice = createSlice({
  name: "biographies",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    builder.addCase(fetchBiographies.pending, (state) => {
      state.listData.loading = true;
    });
    builder.addCase(fetchBiographies.fulfilled, (state, action) => {
      state.listData.loading = false;

      if (action.payload?.success) {
        state.listData.list =
          action.payload?.data?.biographies?.length > 0 ? action.payload?.data?.biographies : [];
        state.listData.count = action.payload?.data?.pagination?.total || 0;
      } else {
        state.listData.list = [];
        state.listData.count = 0;
      }
    });


    builder.addCase(fetchBiographies.rejected, (state) => {
      state.listData.loading = false;
    });
    builder.addCase(downloadBiography.pending, (state, action) => {
      state.listData.downloadingId = action.meta.arg;
      state.listData.downloading = true;

    });

    builder.addCase(downloadBiography.fulfilled, (state) => {
      state.listData.downloadingId = null;

      state.listData.downloading = false;
    });

    builder.addCase(downloadBiography.rejected, (state) => {
      state.listData.downloadingId = null;

      state.listData.downloading = false;
    });

  },
});


export default biographySlice.reducer;
